export enum Maps {
  OSM = "openstreetmap",
  LUFOZOMER = "2023_ortho25",
  LUFOWINTER = "2023_orthoHR",
}
